import * as React from 'react';
import Navbar from '../../containers/NavbarAdmin';
import ProcessMain from '../../containers/ProcessStatus';
import i18n from '../../resources/i18n';
/**
 * 進捗状況表示画面
 * @param props
 */
const ProcessStatusAdmin: React.FC<any> = props => {
	return (
		<>
			<Navbar title={i18n.t('ProcessStatusAdmin_0001')} />
			<ProcessMain adminView={true} {...props} />
		</>
	);
};

export default ProcessStatusAdmin;



// WEBPACK FOOTER //
// ./src/pages/personal/ProcessStatusAdmin.tsx